import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader } from '@dreamtree-org/twreact-ui';
import { useAppApi } from '@/lib/api';
import PlatformLogin from './PlatformLogin';
import Apply from './public/Apply';
import ApplicationStatus from './public/ApplicationStatus';
import AdminJoin from './public/AdminJoin';
import PlatformLayout from './PlatformLayout';
import { platformRoutes } from './routes';
import { PlatformAdminContext, allowed } from './lib/access';
import { EmptyState } from '@/components';

/**
 * Super Admin console (platform admin host only). Session = httpOnly MP_PLATFORM
 * cookie; `/api/platform/me` decides whether we are signed in. Routes come from
 * the manifest in ./routes.jsx.
 */
export default function PlatformApp() {
  const [admin, setAdmin] = useState(undefined); // undefined = checking, null = signed out
  const { fetchApi } = useAppApi();

  const isPublic = typeof window !== 'undefined' && /^\/(apply|join)(\/|$)/.test(window.location.pathname);
  useEffect(() => {
    if (isPublic) {
      setAdmin(null);
      return;
    }
    fetchApi('platformMe', undefined, false)
      .then((res) => setAdmin(res.data))
      .catch(() => setAdmin(null));
  }, []);

  if (admin === undefined) return <Loader text="Loading…" />;

  return (
    <PlatformAdminContext.Provider value={admin || { email: null, permissions: [] }}>
    <Routes>
      {/* public: seller applications (D17), an invited admin's join link */}
      <Route path="/apply" element={<Apply />} />
      <Route path="/apply/status" element={<ApplicationStatus />} />
      <Route path="/join" element={<AdminJoin />} />
      <Route path="/login" element={admin ? <Navigate to="/" replace /> : <PlatformLogin onSignedIn={setAdmin} />} />
      <Route element={admin ? <PlatformLayout admin={admin} onSignedOut={() => setAdmin(null)} /> : <Navigate to="/login" replace />}>
        {platformRoutes.map(({ path, Element, permission }) => (
          <Route
            key={path}
            path={path}
            element={admin && allowed(admin.permissions, permission) ? <Element /> : <EmptyState title="Not available for your role">Ask a super admin for the {permission} permission.</EmptyState>}
          />
        ))}
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </PlatformAdminContext.Provider>
  );
}
